module.exports={
  // base_url:`http://wellworld.id:12317`,
  base_url:`https://api.iidec.id`,
};
